import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { AccessibilityLink } from "@faire/retailer-visitor-shared/lib/AccessibilityLink";
import * as React from "react";
import { useEffect } from "react";
export var HeaderLinkBase = function(props) {
    var onMount = props.onMount, passThroughProps = _object_without_properties(props, [
        "onMount"
    ]);
    useEffect(function() {
        onMount === null || onMount === void 0 ? void 0 : onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ _jsx(AccessibilityLink, _object_spread({}, passThroughProps));
};
